<template>
  <nav>
    <div v-if="surveyOverview">
      <v-row no-gutters class="text-left">
        <v-col cols="12" class="d-inline-flex mb-2">
          <p
            class="text-subtitle-1 no-break font-weight-bold"
            v-html="question.question"
          ></p>
        </v-col>
        <v-col cols="12" class="mb-3" v-if="question.description && strip(question.description).trim() != ''">
          <p
            class="text-subtitle-2 font-weight-regular greytext--text no-break"
            v-html="question.description"
          ></p>
        </v-col>
      </v-row>
      <v-row
        align="center"
        justify="center"
        data-testid="survey-1"
        class="mt-5 mb-3"
      >
        <v-col cols="12" sm="12" :md="pdf ? 9 : 7">
          <v-list-item v-for="answer in question.options" :key="answer.aid">
            <v-text-field
              disabled
              readonly
              dense
              solo
              elevation="8"
              class="survey-answer survey-answer-progress rounded-lg text-body-2 mr-4 replace-box-shadow-input"
              hide-details="auto"
            >
              <template v-slot:prepend-inner>
                <v-icon class="icon-des my-2" color="greytext"
                  >mdi-checkbox-blank-outline</v-icon
                >
                <p
                  data-testid="select-answer"
                  class="font-weight-regular greytext--text text-body-2 my-2 ml-2 align-self-center no-break"
                >
                  {{ answer.option }}
                </p>
                <v-progress-linear
                  v-if="
                    question.stats &&
                    question.stats.hasOwnProperty(answer.aid) &&
                    question.stats[answer.aid]
                  "
                  :value="
                    calculatePercentage(
                      question.stats[answer.aid],
                      numbSubmissions
                    )
                  "
                  height="100%"
                  color="accent"
                  class="progress-bar"
                  absolute
                  top
                  left="0"
                  right="0"
                ></v-progress-linear>
              </template>
              <template v-slot:append-outer>
                <div
                  v-if="
                  question.stats &&
                  question.stats.hasOwnProperty(answer.aid) &&
                  question.stats[answer.aid]
                "
              >
              <span
                >{{
                  calculatePercentage(
                    question.stats[answer.aid],
                    numbSubmissions
                  )
                }}%</span
              >
            </div>
            <div v-else><span class="ml-2">0%</span></div>
              </template>
            </v-text-field>

          </v-list-item>
        </v-col>
      </v-row>
    </div>
    <div v-else-if="user">
      <v-row no-gutters class="text-left">
        <v-col cols="12" class="d-inline-flex mb-2">
          <p
            class="text-subtitle-1 no-break font-weight-bold"
            v-html="question.question"
          ></p>
        </v-col>
        <v-col cols="12" class="mb-3" v-if="question.description && strip(question.description).trim() != ''">
          <p
            class="text-subtitle-2 font-weight-regular greytext--text no-break"
            v-html="question.description"
          ></p>
        </v-col>
      </v-row>
      <v-row
        align="center"
        justify="center"
        data-testid="survey-1"
        class="mt-5 mb-3"
      >
        <v-col cols="12" sm="12" :md="pdf ? 9 : 7">
          <v-list-item v-for="answer in question.options" :key="answer.aid">
            <v-text-field
              disabled
              readonly
              dense
              solo
              elevation="8"
              :class="
                user[question.qid].answer.includes(answer.aid)
                  ? 'survey-answer-individual rounded-lg text-body-2 mr-4'
                  : 'survey-answer rounded-lg text-body-2 mr-4'
              "
              hide-details="auto"
              class="replace-box-shadow-input"
            >
              <template v-slot:prepend-inner>
                <!-- Check if the current answer's aid exists in the object's answer array -->
                <v-icon
                  v-if="user[question.qid].answer.includes(answer.aid)"
                  class="icon-des my-2"
                  color="accent"
                >
                  mdi-checkbox-outline
                </v-icon>
                <v-icon
                  v-else
                  class="icon-des my-2"
                  color="greytext"
                >
                  mdi-checkbox-blank-outline
                </v-icon>
                <p
                  data-testid="select-answer"
                  class="font-weight-regular greytext--text text-body-2 my-2 ml-2 align-self-center no-break row-pointer"
                >
                  {{ answer.option }}
                </p>
              </template>
            </v-text-field>
          </v-list-item>
        </v-col>
      </v-row>
    </div>
    <draggable
      v-else
      :list="question.options"
      class="list-group pl-0"
      ghost-class="ghost-block-answer"
      :force-fallback="true"
      :disabled="published"
      handle=".handle"
    >
      <v-list-item
        v-for="(answer, answerIndex) in question.options"
        :key="answer.aid"
      >
        <v-hover>
          <template v-slot:default="{ hover }">
            <v-text-field
              dense
              solo
              elevation="8"
              v-model="answer.option"
              class="survey-answer rounded-lg text-body-2"
              hide-details="auto"
              :placeholder="$t('surveyTextChoicePlaceholder')"
              :rules="inputRules"
              @click="resetEditor()"
              ref="input"
              @keyup.enter="focusNext($event.target)"
            >
              <template v-slot:prepend>
                <v-icon class="handle" @click="resetEditor()"
                  >mdi-drag-vertical</v-icon
                >
              </template>
              <template v-slot:prepend-inner>
                <v-icon class="handle" @click="resetEditor()"
                  >mdi-checkbox-blank-outline</v-icon
                >
              </template>
              <template v-slot:append v-if="!published">
                <v-icon
                  v-if="hover && question.options.length > 2"
                  @click="deleteAnswer(question, answerIndex)"
                  >mdi-delete-circle</v-icon
                >
              </template>
            </v-text-field>
          </template>
        </v-hover>
      </v-list-item>
    </draggable>
  </nav>
</template>
<script>
import draggable from "vuedraggable";
import {
  ruleRequired,
  answerRuleValid,
} from "../../../rules/formRules.js";
import { repeatedMethodsMixin } from "../../../mixins/repeatedMethodsMixin";

export default {
  props: {
    question: {
      type: Object,
      default: () => {},
    },
    published: {
      type: Boolean,
      default: false,
    },
    surveyOverview: {
      type: Boolean,
      default: false,
    },
    numbSubmissions: {
      type: Number,
      default: 0,
    },
    user: {
      type: Object,
      default: () => {},
    },
    pdf: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    draggable,
  },
  mixins: [repeatedMethodsMixin],
  data() {
    return {
      focusNext(e) {
        const inputs = Array.from(
          e.form.querySelectorAll('input[type="text"]')
        );
        const index = inputs.indexOf(e);
        if (index < inputs.length && inputs[index + 1]) {
          inputs[index + 1].focus();
        }
      },
      inputRules: ruleRequired('labelAnswer').concat(answerRuleValid)
    };
  },


  methods: {
    deleteAnswer(question, answerIndex) {
      this.resetEditor();
      this.$emit("deleteAnswer", question, answerIndex);
    },
    resetEditor() {
      this.$emit("resetEditor");
    }
  },
};
</script>
<style>
.v-progress-linear .v-progress-linear__determinate.accent {
  background-color: #bbdefb80 !important;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  border: 1px solid blue;
}
.survey-answer-individual .v-input__slot {
  background-color: #bbdefb80 !important;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  border: 1px solid blue;
  margin-bottom: 0px;
}
</style>
